import memoize from 'lodash/memoize';
import { wait } from '~/common/js/utils';

// export const insertScript = (src, props = {}) => {
// 	return new Promise((resolve, reject) => {
// 		if (!process?.client) {
// 			reject();
// 		}
// 		if (src) {
// 			const script = document.createElement('script');
// 			try {
// 				Object.keys(props).map((key) => {
// 					script.setAttribute(key, props[key]);
// 				});
// 			} catch (error) {
// 				console.log(111, error);
// 			}
// 			script.src = src;
// 			document.body.appendChild(script);
// 			script.onload = () => resolve();
// 			script.onerror = () => reject();
// 		} else {
// 			reject();
// 		}
// 	});
// };

// export const insertLink = (href, props = {}) => {
// 	if (!process?.client) {
// 		return;
// 	}
// 	if (href) {
// 		let link = document.createElement('link');
// 		try {
// 			Object.keys(props).map((key) => {
// 				link.setAttribute(key, props[key]);
// 			});
// 		} catch (error) {
// 			console.log(111, error);
// 		}
// 		link.rel = 'stylesheet';
// 		link.type = 'text/css';
// 		link.href = href;
// 		let head = document.getElementsByTagName('head')[0];
// 		head.appendChild(link);
// 	}
// };

export const breakDownHostUrl = (url: string) => {
  let hostUrl = url;
  let newUrl = hostUrl;
  // 防止未做301跳转，产生XXX.XXX的域名
  if (hostUrl.split('.') && hostUrl.split('.').length <= 2) {
    newUrl = hostUrl;
  } else {
    let number = hostUrl.indexOf('.');
    newUrl = hostUrl.slice(number + 1);
  }
  return newUrl;
};
  
const LOCAL_DOMAIN_MAP = new Map([
  ['production', 'bitmart.com'],
  ['testing', 'bitmartgcp-test.com'],
  ['dev', 'bitmart-dev.com'],
]);
const LEGACY_TESTING_DOMAIN = 'bitmarttest.com';
  

export const getAppDyamicHost=memoize(async ()=>{

  const bitMartAppPattern = /BitMart/;
  const isAppRuntime = bitMartAppPattern.test(navigator?.userAgent);
  if (isAppRuntime) {
    const diff = 100;
    let totalTime = 0;

    // eslint-disable-next-line no-constant-condition
    while (true) {
      if (window.jsBridge && window.jsBridge.getDomainData) {
        break;
      } else {
        if (totalTime >= 1500) {
          console.log('no getDomainData');
          break;
        }
        await wait(diff);
        totalTime += diff;
      }
    }
  }
  return new Promise((resolve)=>{

    if (window.jsBridge && window.jsBridge.getDomainData) {
      console.log('getDomainData');
      window.jsBridge.getDomainData((res)=>{
        try {
          res=JSON.parse(res);
          
        } catch (_error) {
        res = res.substring(15,res.length-2);
        res=JSON.parse(res);
          
        }
          
          if (typeof res.domainData==='string') {
            res=JSON.parse(res.domainData);
          }

          if (typeof res?.domain_list==='string') {
            res=JSON.parse(res.domain_list);
          }
        

          const {domain_list}=res;   
          const domainsMap:any={};
          const domainObj=domain_list.find((item)=>{
            return Object.keys(item).find((key)=>{
              const {host}=domainObj[key];
             return process.env.DERIVATIVES_HOST?.includes(host)||process.env.MASTER_HOST?.includes(host);
            });
          })||domain_list?.[0];

          if (domainObj) {
            Object.keys(domainObj).forEach((key)=>{
              const {host}=domainObj[key];
            if (host.length) {
              domainsMap[key]=host;
            }
          });
          }

          resolve(domainsMap);
        });
    }
  });
});

export const getCurHost = memoize((origin: string) => {
  let url;
  let dynamicHost:any;
  let isInApp;

  // 当前域名是否为合约域名
  const isDerivatives = process.env.PROJECT_NAME==='DERIVATIVES';
  if (process.client) {
    isInApp = (/BitMart/).test(navigator?.userAgent);
    getAppDyamicHost().then((res)=>{
      dynamicHost=res;
      console.log('getAppDyamicHost', res);
    });
    const domainPattern=/(bitmartgcp-(dev|test)|bitmart)+\.(com|cool)$/;

    if (!isInApp&&!domainPattern.test(location.host)&&process.env.NODE_ENV != 'development') {
      if (isDerivatives) {
        location.href=location.href.replace(location.origin,process.env.DERIVATIVES_HOST as string);
      }else{
        location.href=location.href.replace(location.origin,process.env.MASTER_HOST as string);
      }
    }
  }
  try {
    if (isInApp) {
      if (isDerivatives) {
        url = new URL(process.env.DERIVATIVES_HOST as string);
      }else{
        url = new URL(process.env.MASTER_HOST as string);
      }
    }else{
      url = new URL(origin);
    }
  } catch (error) {
    console.log(111, error);
  }
  // console.log('domain_env', process.env.domain_env);
  const isLocal = process.env.NODE_ENV === 'development';
  const isTest = process.env.domain_env === 'testing';

  // console.log('url', url);
  let endFix, isBeta, protocol = 'https:', hostFix='com';
  if (url) {
    endFix = breakDownHostUrl(url.host); // bitmartgcp-test.com / bitmartgcp-test.cool / bitmart.com / bitmart.cool
    isBeta = url.hostname.includes('beta.');
    protocol = url.protocol;
  } else {
    endFix = 'bitmart.com';
    isBeta = false;
  }
  const hostFixArr = endFix.split('.');
  hostFix = hostFixArr[hostFixArr.length - 1];
  let contractEndFix = endFix;
  // console.log('contractEndFix', contractEndFix);

  if (isLocal) {
    endFix = LOCAL_DOMAIN_MAP.get(process.env.domain_env as string) as string;
    if (isTest) {
      contractEndFix = LEGACY_TESTING_DOMAIN;
    } else {
      contractEndFix = endFix;
    }
    protocol = 'https:';
  } else if (isTest) {
    contractEndFix = `bitmarttest.${hostFix}`;
  }

  let siteOrigin;
  if (isBeta) {
    siteOrigin = `${protocol}//beta.${endFix}`; // 主站的 地址
  } else {
    siteOrigin = `${protocol}//www.${endFix}`; // 主站的 地址
  }

  let derivativesOrigin;
  if (isBeta) {
    derivativesOrigin = siteOrigin.replace('beta.', 'derivatives-beta.');
  } else {
    derivativesOrigin = siteOrigin.replace('www.', 'derivatives.');
  }
  const cookieDomain = `.${endFix}`;

  let wssHostV2;
  let wssDemoHost;
  let demoContractApiHost;
  let contractApiHostV2;
  let contractApiHost;
  let wssHost;
  let wsUrl;
  if (isTest) {
    // wssHostV2 = 'wss://'+dynamicHost.get('contract-ws-sandbox.bitmarttest.com');
    // contractApiHostV2 = `${protocol}//${dynamicHost.get('contract-sandbox.bitmarttest.com')}`;
    wssHostV2 = `wss://contract-ws-sandbox.${contractEndFix}`;
    contractApiHostV2 = `${protocol}//contract-sandbox.bitmarttest.com`;
    demoContractApiHost = `${protocol}//contract-simulation.${contractEndFix}`;
    contractApiHost = `${protocol}//contract.${contractEndFix}`;
    wssHost = `wss://contractapp.${contractEndFix}`;
    wsUrl ='wss://ws-manager-compress.bitmartgcp-test.com';
    wssDemoHost = 'wss://contract-ws-simulation.bitmarttest.com';
  } else {
    wssHostV2 = `wss://contract-ws-v2.${contractEndFix}`;
    demoContractApiHost = `${protocol}//contract-simulation.${contractEndFix}`;
    contractApiHostV2 = `${protocol}//contract-v2.${contractEndFix}`;
    contractApiHost = `${protocol}//contract.${contractEndFix}`;
    wssHost = `wss://contractapp.${contractEndFix}`;
    wsUrl ='wss://ws-manager-compress-web.bitmart.com';
    wssDemoHost = 'wss://contract-ws-simulation.bitmarttest.com';
  }

  // 所有的域名集合
  const allOrigin = [...new Set(
    [
      siteOrigin,
      siteOrigin?.replace('.com', '.cool'),
      siteOrigin?.replace('.cool', '.com'),
    ]
  )];

  const findUrlStart = (url: string) => allOrigin.find(() => url.startsWith(origin));


  const siteConfig = {
    origin: siteOrigin,
    derivativesOrigin, // https://derivatives.bitmart.com
    cookieDomain, // .bitmart.com
    isBeta,
    isDerivatives,
    contractApiHost,
    contractApiHostV2,
    demoContractApiHost,
    wssDemoHost,
    wssHost,
    wssHostV2,
    endFix,
    wsUrl,
    allOrigin,
    findUrlStart,
    isInApp,
    sentryHost:process.env.SENTRY_DSN||'',
    imgCdnHost:process.env.IMG_CDN_PREFIX
  };
  if (process.env.ENV !== 'production' && process.env.NODE_ENV === 'development') {
    console.log('getCurHost', siteConfig);
  }
  const ob={...siteConfig};
  Object.defineProperty(ob, 'wssHostV2', {
    get() {
      console.log('in wssHost',dynamicHost);
        if (dynamicHost?.['contract-ws-sandbox.bitmarttest.com']) {
          return 'https://'+dynamicHost?.['contract-ws-sandbox.bitmart.com'];
        }else if (dynamicHost?.['contract-ws-v2.bitmart.com']) {
          return 'https://'+dynamicHost?.['contract-ws-v2.bitmart.com'];
        }else{
          return siteConfig.wssHostV2;
        }
    },
  });
  Object.defineProperty(ob, 'wssDemoHost', {
    get() {
      // console.log('in wssHost',dynamicHost)
      if (dynamicHost?.['contract-ws-simulation.bitmarttest.com']) {
        return 'wss://'+dynamicHost?.['contract-ws-simulation.bitmarttest.com'];
      }else if (dynamicHost?.['contract-ws-v2.bitmart.com']) {
        return 'wss://'+dynamicHost?.['contract-ws-v2.bitmart.com'];
      }else{
        return siteConfig.wssDemoHost;
      }
    },
  });
  Object.defineProperty(ob, 'wsUrl', {
    get() {
      console.log('in wsUrl',dynamicHost);
        if (dynamicHost?.['ws-manager-compress.bitmartgcp-test.com']) {
          return 'wss://'+dynamicHost?.['ws-manager-compress.bitmartgcp-test.com'];
        }else if (dynamicHost?.['ws-manager-compress-web.bitmart.com']) {
          return 'wss://'+dynamicHost?.['ws-manager-compress-web.bitmart.com'];
        }else{
          return siteConfig.wsUrl;
        }
    },
  });
  Object.defineProperty(ob, 'contractApiHostV2', {
    get() {
      console.log('in contractApiHostV2',dynamicHost);
        if (dynamicHost?.['contract-sandbox.bitmarttest.com']) {
          return 'https://'+dynamicHost?.['contract-sandbox.bitmarttest.com'];
        }else if (dynamicHost?.['contract-v2.bitmart.com']) {
          return 'https://'+dynamicHost?.['contract-v2.bitmart.com'];
        }else{
          return siteConfig.contractApiHostV2;
        }
    },
  });
  Object.defineProperty(ob, 'demoContractApiHost', {
    get() {
      if (dynamicHost?.['contract-simulation.bitmarttest.com']) {
        return 'https://'+dynamicHost?.['contract-simulation.bitmarttest.com'];
      }else{
        return siteConfig.demoContractApiHost;
      }
    },
  });
  Object.defineProperty(ob, 'sentryHost', {
    get() {
      console.log('in sentryHost',dynamicHost);
        if (dynamicHost?.['sentryingest.bitmart.com']) {
          return siteConfig.sentryHost?.replace('sentryingest.bitmart.com',dynamicHost?.['sentryingest.bitmart.com']);
        }else{
          return siteConfig.sentryHost;
        }
    },
  });
  Object.defineProperty(ob, 'imgCdnHost', {
    get() {
      console.log('in imgCdnHost',dynamicHost);
        if (dynamicHost?.['img.bitmart.com']) {
          return siteConfig.imgCdnHost?.replace('img.bitmart.com',dynamicHost?.['img.bitmart.com']);
        }else{
          return siteConfig.imgCdnHost;
        }
    },
  });
  return ob;
});